import { enAU, enNZ, enUS, id, th } from 'date-fns/locale';
import type * as dateFns from 'date-fns';
import type { Locale as MelwaysLocale } from '@seek/melways-sites';

export const languageToLocaleMap: { [K in MelwaysLocale]: dateFns.Locale } = {
  'en-AU': enAU,
  'en-HK': enUS,
  'en-ID': enUS,
  'en-MY': enUS,
  'en-NZ': enNZ,
  'en-PH': enUS,
  'en-SG': enUS,
  'en-TH': enUS,
  'id-ID': id,
  'th-TH': th,
};
